var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmEx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 68,
    viewBox: "0 0 102 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 68,
    rx: 7.55556,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 100,
    height: 66,
    rx: 6.55556,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "AmEx Logo"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.018 50.4334V57.8227H91.634L88.166 53.7654L84.562 57.8227H57.906V36.2214H49.1113L60.1048 11.3334H70.8033L73.3873 16.9774V11.3334H86.67L88.8913 17.2494L91.0673 11.3334H101.018V14.8467H93.334L89.8433 24.0494L88.914 26.5427L84.4487 14.8467H76.7647V32.98L68.786 14.8467H62.5981L54.574 32.98H59.8328L61.2381 29.4894H70.0328L71.4381 32.98H76.7647H81.3888V21.1707L81.366 18.7907L82.2728 21.1707L86.6927 32.98H91.09L95.5327 21.1707L96.394 18.8134V32.98H101.018V40.0747L95.8953 45.22L101.018 50.4334ZM61.6233 54.3094V36.2439H76.7647V40.1654H66.2473V43.3387H76.5608V47.2374H66.2473V50.3879H76.7647V54.3094H61.6233ZM99.6128 54.3094H93.606L88.1207 48.416L82.6127 54.3094H76.7647L85.2193 45.3106L76.7647 36.2439H82.794L88.234 42.1147L93.6968 36.2439H99.6128L91.1353 45.2426L99.6128 54.3094Z",
    fill: "#C8283B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6353 18.7227L64.7288 20.9894L62.8473 25.568H68.4233L66.542 20.9894L65.6353 18.7227Z",
    fill: "#C8283B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmEx);
export default __webpack_public_path__ + "static/media/amEx.0dff936ec023766d41cb763c42f21898.svg";
export { ForwardRef as ReactComponent };